module.exports = __webpack_public_path__ + "img/training_course_3.fedf189f.jpg";